/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceNachrichtentyp as AceXFoundPortalCoreEntitiesGlobalEnumsAceNachrichtentyp } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-nachrichtentyp';
import { AceNachrichtAceNachrichtEnumsAceNachrichtStatuscode as AceXFoundPortalCoreEntitiesAceNachrichtAceNachrichtEnumsAceNachrichtStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-nachricht-ace-nachricht-enums-ace-nachricht-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface INachrichtDisplayModel {
  absender?: null | string;
  anfrageid?: string;
  antwort?: null | string;
  bearbeitetAm?: string;
  erstelltAm?: string;
  id?: null | string;
  nachrichtentyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceNachrichtentyp;
  statusgrund?: AceXFoundPortalCoreEntitiesAceNachrichtAceNachrichtEnumsAceNachrichtStatuscode;
  subject?: null | string;
  text?: null | string;
}
export class NachrichtDisplayModel extends BaseModel implements INachrichtDisplayModel {
  absender?: null | string;
  anfrageid?: string;
  antwort?: null | string;
  bearbeitetAm?: string;
  erstelltAm?: string;
  id?: null | string;
  nachrichtentyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceNachrichtentyp;
  statusgrund?: AceXFoundPortalCoreEntitiesAceNachrichtAceNachrichtEnumsAceNachrichtStatuscode;
  subject?: null | string;
  text?: null | string;
}
class BaseNachrichtDisplayModelFormGroup extends FormGroup {
  private static _instance: NachrichtDisplayModelFormGroup;
  
  public static get Instance(): NachrichtDisplayModelFormGroup {
    this._instance = new NachrichtDisplayModelFormGroup({
      absender: new FormControl(null),
      anfrageid: new FormControl(null),
      antwort: new FormControl(null),
      bearbeitetAm: new FormControl(null),
      erstelltAm: new FormControl(null),
      id: new FormControl(null),
      nachrichtentyp: new FormControl(null),
      statusgrund: new FormControl(null),
      subject: new FormControl(null),
      text: new FormControl(null),
    });

    return this._instance;
  }
}


export class NachrichtDisplayModelFormGroup extends BaseNachrichtDisplayModelFormGroup {
  public get Absender(): FormControl {
    return this.controls["absender"] as FormControl;
  }
  public get Anfrageid(): FormControl {
    return this.controls["anfrageid"] as FormControl;
  }
  public get Antwort(): FormControl {
    return this.controls["antwort"] as FormControl;
  }
  public get BearbeitetAm(): FormControl {
    return this.controls["bearbeitetAm"] as FormControl;
  }
  public get ErstelltAm(): FormControl {
    return this.controls["erstelltAm"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Nachrichtentyp(): FormControl {
    return this.controls["nachrichtentyp"] as FormControl;
  }
  public get Statusgrund(): FormControl {
    return this.controls["statusgrund"] as FormControl;
  }
  public get Subject(): FormControl {
    return this.controls["subject"] as FormControl;
  }
  public get Text(): FormControl {
    return this.controls["text"] as FormControl;
  }
  

}

export module NachrichtDisplayModelForm
  {
    export class FormFields
    {
      static _absender: string = "absender";
      static _anfrageid: string = "anfrageid";
      static _antwort: string = "antwort";
      static _bearbeitetAm: string = "bearbeitetAm";
      static _erstelltAm: string = "erstelltAm";
      static _id: string = "id";
      static _nachrichtentyp: string = "nachrichtentyp";
      static _statusgrund: string = "statusgrund";
      static _subject: string = "subject";
      static _text: string = "text";
    }
  }

